<app-empty-state
    i18n-title
    title="[***] No questions defined yet"
    type="noData"
>
    <span i18n>[***] Start adding questions for your customers' onboarding process...</span>
    <br />
</app-empty-state>
